import React, { useEffect } from "react";
import { configApiRef, useApi, useRouteRef } from '@backstage/core-plugin-api';
import { PageLayout } from "tmna-ui-kit";
import { Insights } from "../../components/Insights";
import { rootRouteRef } from "../../routes";
import { useLocation } from "react-use";
import { DashboardCategory, DashboardMetaData } from "../../insights-types";
import { makeStyles } from "@material-ui/core";
import { APPLICATION_HEALTH_DASHBOARD, APPLICATION_HEALTH_DASHBOARD_DESCRIPTION, APPLICATION_HEALTH_DASHBOARD_TECH_DOCS, CLOUD_SCORE_CARD, DEVOPS, SERVICENOW, SONARQUBE, TMNA_GITHUB } from "../../insights-constants";

const useStyles = makeStyles(() => ({
    pageContent: {
        height: '100vh',
        display: 'flex',
        flexDirection: 'column'
    }
}));

export const DashboardPage = () => {
    const classes = useStyles();
    const configApi = useApi(configApiRef);
    const appHealthDashboardId = configApi.getString('app.appHealthDashboardId');
    const getInsightsPageRoute = useRouteRef(rootRouteRef);
    const location = useLocation();
    const dashboardMetaData = (location.state?.usr as DashboardMetaData) ?? {
      category: DashboardCategory.APPLICATION_PLATFORM_COMPLIANCE,
      dashboardId: appHealthDashboardId,
      dashboardName: APPLICATION_HEALTH_DASHBOARD,
      description: APPLICATION_HEALTH_DASHBOARD_DESCRIPTION,
      dataSources: [
        SERVICENOW, TMNA_GITHUB, SONARQUBE, CLOUD_SCORE_CARD, DEVOPS
      ],
      techDocs: APPLICATION_HEALTH_DASHBOARD_TECH_DOCS
    };
    useEffect(() => {
        document.body.className = '';
        return () => {
        };
    }, []);

    const backToLink = React.useMemo(() => ({
        label: 'Back to Chofer Insights',
        to: getInsightsPageRoute(),
    }), [getInsightsPageRoute]);

    return (
        <div className={classes.pageContent}>
            <PageLayout
                type="entity"
                title={dashboardMetaData.dashboardName}
                backToLink={backToLink}
                subtitle={dashboardMetaData.description}
                displayButton={true}
            >
                <Insights dashboardId={dashboardMetaData.dashboardId} />
            </PageLayout>
        </div>
    );
};
